export const SAVE_LOGIN_OBJ = "SAVE_LOGIN_OBJ";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
